if (!customElements.get("lsg-articles-recipe")) {
  class LsgArticlesRecipe extends HTMLElement {
    constructor() {
      super();

      this.btnLoadMoreArticles = this.querySelector(
        ".js-lsg-articles-recipe-load-more"
      );
      this.articlesWrapper = document.querySelector(".js-lsg-articles-recipe");
    }

    connectedCallback() {
      this.sectionName = this.btnLoadMoreArticles.dataset.sectionName;
      window.addEventListener("scroll", this.debounceHandleScroll);
      //this.debounceHandleScroll = this.debounce(this.handleScroll.bind(this), 50);
      this.btnLoadMoreArticles.addEventListener(
        "click",
        this.handleLoadMoreClick.bind(this)
      );
    }

    handleScroll() {
      if (
        this.isInViewport(this.btnLoadMoreArticles) &&
        !this.btnLoadMoreArticles.disabled
      ) {
        this.loadMoreArticlesHandler();
      }
    }

    handleLoadMoreClick() {
      this.loadMoreArticlesHandler();
    }

    async loadMoreArticlesHandler() {
      this.btnLoadMoreArticles.disabled = true;
      try {
        const response = await fetch(
          this.btnLoadMoreArticles.dataset.nextUrl +
            "&sections=" +
            this.sectionName
        );
        const data = await response.json();
        const html = new DOMParser().parseFromString(
          data[this.sectionName],
          "text/html"
        );
        const newArticles = html?.querySelectorAll(
          ".js-lsg-article-recipe-card"
        );
        const newButton = html?.querySelector(
          ".js-lsg-articles-recipe-load-more"
        );

        if (html) {
          if (!!newArticles?.length && this.articlesWrapper) {
            newArticles.forEach((article) => {
              this.articlesWrapper.appendChild(article);
            });
          }

          if (newButton) {
            this.btnLoadMoreArticles.dataset.nextUrl =
              newButton.dataset.nextUrl;
            this.btnLoadMoreArticles.disabled = false;
          } else {
            this.btnLoadMoreArticles.remove();
          }
        }
      } catch (error) {
        console.error("Error blog recipe load more:", error);
      }
    }

    isInViewport(elem) {
      const rect = elem.getBoundingClientRect();
      return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    debounce(func, delay) {
      let timeout;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, delay);
      };
    }
  }

  customElements.define("lsg-articles-recipe", LsgArticlesRecipe);
}
